export const formatPhone = (phone) => {
  const phoneStr = String(phone)
  const regexp = /\+?([0-9]{2})([0-9]{3})([0-9]{3})([0-9]{4})/

  return phoneStr.replace(regexp, '+$1 ($2) $3 $4')
}
